type SupportRequestHeaderProps = {
  onClose: () => void;
};

export const SupportRequestHeader = ({ onClose }: SupportRequestHeaderProps) => {
  return (
    <div className="flex-shrink-0 px-6 pt-6 pb-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-[#111827]">Support Request Form</h2>
        <button
          type="button"
          onClick={onClose}
          className="text-[#9AA3B7] transition-colors hover:text-[#6f778c]"
          aria-label="Close modal"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 5l10 10M15 5L5 15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

